/**
 * Message
 * The Message API
 *
 * The version of the OpenAPI document: master-8247d258-900790
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@nestjs/common';
import { HttpService } from '@nestjs/axios';
import { AxiosResponse } from 'axios';
import { Observable } from 'rxjs';
import { CreateTemplateRequest } from '../model/createTemplateRequest';
import { PaginatedTemplateDto } from '../model/paginatedTemplateDto';
import { PaginatedTemplateDtoAllOfDataInner } from '../model/paginatedTemplateDtoAllOfDataInner';
import { UpdateTemplateRequest } from '../model/updateTemplateRequest';
import { Configuration } from '../configuration';
import { COLLECTION_FORMATS } from '../variables';


@Injectable()
export class TemplateApi {

    protected basePath = 'http://.';
    public configuration = new Configuration();

    constructor(protected httpClient: HttpService, @Optional() configuration: Configuration) {
        this.configuration = configuration || this.configuration;
        this.basePath = configuration?.basePath || this.basePath;
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        return consumes.includes(form);
    }

    /**
     * 
     * 
     * @param createTemplateRequest 
     */
    public createTemplate(createTemplateRequest: CreateTemplateRequest, ): Observable<AxiosResponse<PaginatedTemplateDtoAllOfDataInner>>;
    public createTemplate(createTemplateRequest: CreateTemplateRequest, ): Observable<any> {

        if (createTemplateRequest === null || createTemplateRequest === undefined) {
            throw new Error('Required parameter createTemplateRequest was null or undefined when calling createTemplate.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.post<PaginatedTemplateDtoAllOfDataInner>(`${this.basePath}/template`,
            createTemplateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public deleteTemplate(id: string, ): Observable<AxiosResponse<PaginatedTemplateDtoAllOfDataInner>>;
    public deleteTemplate(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTemplate.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.delete<PaginatedTemplateDtoAllOfDataInner>(`${this.basePath}/template/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public getTemplate(id: string, ): Observable<AxiosResponse<PaginatedTemplateDtoAllOfDataInner>>;
    public getTemplate(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTemplate.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<PaginatedTemplateDtoAllOfDataInner>(`${this.basePath}/template/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param limit 
     * @param offset 
     * @param search Search by title, description or id
     * @param type 
     * @param sort Sort by one or more properties. Use \&#39;+\&#39; for ascending and \&#39;-\&#39; for descending.
     */
    public getTemplates(limit?: number, offset?: number, search?: string, type?: Array<'chat' | 'broadcast'>, sort?: Array<'+title' | '-title' | '+description' | '-description' | '+updatedAt' | '-updatedAt'>, ): Observable<AxiosResponse<PaginatedTemplateDto>>;
    public getTemplates(limit?: number, offset?: number, search?: string, type?: Array<'chat' | 'broadcast'>, sort?: Array<'+title' | '-title' | '+description' | '-description' | '+updatedAt' | '-updatedAt'>, ): Observable<any> {






        let queryParameters = new URLSearchParams();
        if (limit !== undefined && limit !== null) {
            queryParameters.append('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters.append('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters.append('search', <any>search);
        }
        if (type) {
            type.forEach((element) => {
                queryParameters.append('type', <any>element);
            })
        }
        if (sort) {
            queryParameters.append('sort', sort.join(COLLECTION_FORMATS['csv']));
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<PaginatedTemplateDto>(`${this.basePath}/template`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param updateTemplateRequest 
     */
    public updateTemplate(id: string, updateTemplateRequest: UpdateTemplateRequest, ): Observable<AxiosResponse<PaginatedTemplateDtoAllOfDataInner>>;
    public updateTemplate(id: string, updateTemplateRequest: UpdateTemplateRequest, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateTemplate.');
        }

        if (updateTemplateRequest === null || updateTemplateRequest === undefined) {
            throw new Error('Required parameter updateTemplateRequest was null or undefined when calling updateTemplate.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.patch<PaginatedTemplateDtoAllOfDataInner>(`${this.basePath}/template/${encodeURIComponent(String(id))}`,
            updateTemplateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
}
